import { entityStorageFactory } from "@/core/shared/storage/infrastructure/entityStorage";
import { Auth } from "@/core/user/domain/auth";

export const authStorage = ({ storage }: { storage: Storage }) => entityStorageFactory<Auth>(storage, "auth");
